/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

import * as Types from '../../../../../types/FMSGraphqlTypes'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type ITrailerDetailsQueryVariables = Types.Exact<{
  trailerId?: Types.Maybe<Types.Scalars['ID']>
  trailerNumber?: Types.Maybe<Types.Scalars['String']>
}>

export type ITrailerDetailsQuery = { __typename?: 'Query' } & {
  trailer: { __typename?: 'Trailer' } & Pick<
    Types.ITrailer,
    'id' | 'number' | 'state' | 'trailerType' | 'length' | 'note' | 'arrivedAt' | 'carrierName'
  > & {
      shipmentDetails?: Types.Maybe<
        { __typename?: 'TrailerShipmentDetails' } & Pick<
          Types.ITrailerShipmentDetails,
          | 'id'
          | 'state'
          | 'pickupArrivedAt'
          | 'pickupTrailerArrivedAt'
          | 'pickupTrailerEmptiedAt'
          | 'pickupIsDrop'
          | 'pickupCity'
          | 'pickupStateCode'
          | 'pickupTimezone'
          | 'deliveryArrivedAt'
          | 'deliveryTrailerEmptiedAt'
          | 'deliveryTrailerArrivedAt'
          | 'deliveryIsDrop'
          | 'deliveryCity'
          | 'deliveryStateCode'
          | 'deliveryTimezone'
        >
      >
      facility?: Types.Maybe<
        { __typename?: 'TrailerShipperFacility' } & Pick<
          Types.ITrailerShipperFacility,
          'id' | 'name' | 'uuid' | 'timezone'
        >
      >
    }
}

export const TrailerDetailsDocument = gql`
  query TrailerDetails($trailerId: ID, $trailerNumber: String) {
    trailer(trailerId: $trailerId, trailerNumber: $trailerNumber) {
      id
      number
      state
      trailerType
      length
      note
      arrivedAt
      carrierName
      shipmentDetails {
        id
        state
        pickupArrivedAt
        pickupTrailerArrivedAt
        pickupTrailerEmptiedAt
        pickupIsDrop
        pickupCity
        pickupStateCode
        pickupTimezone
        deliveryArrivedAt
        deliveryTrailerEmptiedAt
        deliveryTrailerArrivedAt
        deliveryIsDrop
        deliveryCity
        deliveryStateCode
        deliveryTimezone
      }
      facility {
        id
        name
        uuid
        timezone
      }
    }
  }
`

/**
 * __useTrailerDetailsQuery__
 *
 * To run a query within a React component, call `useTrailerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrailerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrailerDetailsQuery({
 *   variables: {
 *      trailerId: // value for 'trailerId'
 *      trailerNumber: // value for 'trailerNumber'
 *   },
 * });
 */
export function useTrailerDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<ITrailerDetailsQuery, ITrailerDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ITrailerDetailsQuery, ITrailerDetailsQueryVariables>(
    TrailerDetailsDocument,
    options
  )
}
export function useTrailerDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ITrailerDetailsQuery, ITrailerDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ITrailerDetailsQuery, ITrailerDetailsQueryVariables>(
    TrailerDetailsDocument,
    options
  )
}
export type TrailerDetailsQueryHookResult = ReturnType<typeof useTrailerDetailsQuery>
export type TrailerDetailsLazyQueryHookResult = ReturnType<typeof useTrailerDetailsLazyQuery>
export type TrailerDetailsQueryResult = Apollo.QueryResult<
  ITrailerDetailsQuery,
  ITrailerDetailsQueryVariables
>
